import { createClient } from 'prismicio';

import { EMPTY_THEME_TYPOGRAPHY } from '@/constants';
import type { ThemeTypography } from '@/types';

export async function getTheme(): Promise<ThemeTypography> {
  const client = createClient();

  try {
    const { data } = await client.getSingle('theme');

    return {
      heading: {
        name: data.heading_font_family || null,
        url: data.heading_font_url || null,
      },
      body: {
        name: data.font_family || null,
        url: data.font_url || null,
      },
    };
  } catch {
    return EMPTY_THEME_TYPOGRAPHY;
  }
}
